import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { defaultThemeSetting as dts } from 'config/promoDefaultSettingValue';

export default function usePromoSettingThemeStyle({ useDefault = false } = {}) {
    const settingTheme = useSelector(s => s.settingTheme);

    return useMemo(() => {
        if (useDefault) {
            return dts;
        }
        const {
            bgColor = dts.bgColor,
            btnColor = dts.btnColor,
            textColor = dts.textColor
        } = settingTheme;
        return {
            contentBgColor: bgColor,
            btnColor,
            textColor
        };
    }, [useDefault, settingTheme]);
}
